export const statusTable = {
  pay: 'pagado',
  notPay: 'no pagado',
};
